
<a class="btn" :class="{ disabled }" :href="disabled ? '' : link">{{ title }}</a>
